import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";

const ClientAdmin = () => {
    const [customers, setCustomers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        checkAdminStatus();
    }, []);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllCustomers();
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllCustomers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }
    
            const response = await axios.get('https://hbmdijital.online/api/admin/customers', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
    
            if (response.status === 200) {
                setCustomers(response.data);
            } else {
                console.error('Failed to fetch customers:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    
    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <h1 className="text-dark display-4">Clients</h1>
                    </div>
                    <hr className="my-4" />

                    {/* Customers Table - Make it responsive */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>ID Client</th>
                                    <th>ID Fournisseur</th>
                                    <th>Nom</th>
                                    <th>Email</th>
                                    <th>Téléphone</th>
                                    <th>Adresse</th>
                                    <th>Ville</th>
                                    <th>Créé Le</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers.map((customer) => (
                                    <tr key={customer.CustomerID}>
                                        <td>{customer.CustomerID}</td>
                                        <td>{customer.SupplierCustomID}</td>
                                        <td>{customer.Name}</td>
                                        <td>{customer.Email}</td>
                                        <td>{customer.Phone || 'N/A'}</td>
                                        <td>{customer.Address}</td>
                                        <td>{customer.City}</td>
                                        <td>{new Date(customer.created_at).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default ClientAdmin;
